import { trace } from '@opentelemetry/api'

import safeFetch from '@/lib/helpers/safe-fetch'
import { passCacheClientSingleton } from '@/lib/cache/client'
import { CS_CACHE_TIME } from '@/lib/constants'

async function cachedFetch(input: RequestInfo | URL, ttl: number = CS_CACHE_TIME, init?: RequestInit) {
  return await trace.getTracer('cachedFetch').startActiveSpan('cached-fetch-span', async (span) => {
    const cacheClient = await passCacheClientSingleton()
    const key = input.toString()
    const cachedResponse = await cacheClient.get(key)
  
    if(cachedResponse) {
      return cachedResponse
    }

    const response = await safeFetch(input, { ...init, cache: 'no-store' })
    const json = await response.json()
  
    cacheClient.set(key, json, ttl, { allowGraduatedResponse: true })

    span.end()
    return json
  })
}

export default cachedFetch
